import { network } from 'services/network';

export const getLanguages = () => {
    return network.post('api/bo/getLanguages').then((response) => {
        return response.data;
    });
};
